

import { Google } from '@mui/icons-material'
import { Button } from '@mui/material'
import React, { useState } from 'react'
import { useValue } from '../../context/ContextProvider'
import { jwtDecode } from 'jwt-decode'      //Para decodificar la respuesta de Google OneTap.  Se instalo con: "npm i jwt-decode"

const GoogleOneTapLogin = () => {

    const { dispatch } = useValue();        //Para mostrar un alert al usuario en caso de ser necesario

    const [disabled, setDisabled] = useState(false);

    const handleResponse = (response) => {
        const token = response.credential;
        const decodedToken = jwtDecode(token);
        //console.log(decodedToken);
        const {sub:id, email, name, picture:photoURL } = decodedToken;
        dispatch({type: 'UPDATE_USER', payload: {id, email, name, photoURL, token, google:true}});
        dispatch({type: 'CLOSE_LOGIN'});
    }

    const handleGoogleLogin = () => {
        setDisabled(true);
        try {
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                callback: handleResponse
            })
            window.google.accounts.id.prompt((notification) => {
                if(notification.isNotDisplayed()){
                    /*  Sólo para desarrollo, se cambia la expiración de la cockie que evita que por cierto tiempo (2 Horas) 
                        la ventana de cuentas se vea. */
                    document.cookie =  `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
                    //window.google.accounts.id.prompt();
                    //Si la respuesta no llega se muestra el mensaje de error
                    throw new Error('Intente borrando las cookies o intente nuevamente en unos minutos.')
                }
                if(notification.isSkippedMoment() || notification.isDismissedMoment()) {
                    /*  Sólo para desarrollo, se cambia la expiración de la cockie que evita que por cierto tiempo (2 Horas) 
                        la ventana de cuentas se vea. */
                    document.cookie =  `g_state=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
                    //Si el usuario hizo click fuera de la ventana o se salió de la solicitud
                    setDisabled(false);
                }
            })
        } catch (error) {
            dispatch({
                type: 'UPDATE_ALERT', 
                payload: {open: true, severity: 'error', message: error.message}
            });
            //console.log("MiError: ", error);
        }
    }

  return (
    <Button
        variant='outlined'
        startIcon={<Google />}
        disabled={disabled}
        onClick={handleGoogleLogin}
    >
        Login con Google
    </Button>
  )
}

export default GoogleOneTapLogin